export class EngagementStatusViewModel{
    engagementId: number;
    workspaceId: string;
    status: string;
    engagementState:string;
    changeOrderState:string;
    changeOrderId:number;
}